import { render, staticRenderFns } from "./fontPicker.vue?vue&type=template&id=cf4491d8"
import script from "./fontPicker.vue?vue&type=script&lang=js"
export * from "./fontPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports